import type { PostHogConfig } from 'posthog-js';
import { scrubOAuthCapture, scrubOAuthNetworkRequest } from './posthog-oauth-scrubber';

/**
 * Reglages de `posthog.init` pour le back-office, a part de `main.ts` pour pouvoir les tester.
 *
 * - RGPD : pas de profil pour les visiteurs anonymes ; session replay avec masquage strict
 *   (donnees users) : tous les inputs sont masques, et le texte sensible AFFICHE doit porter la
 *   classe CSS `ph-no-capture` (ecran de confirmation de Discord compris).
 * - Retour OAuth de Discord : `code` et `state` ne partent jamais dans les evenements
 *   (`before_send`, `maskCapturedNetworkRequestFn`).
 * - `recordHeaders` et `recordBody` a `false` : la valeur du client l'emporte toujours sur la
 *   configuration a distance du projet PostHog. Sans cela, activer « capture network payloads »
 *   dans le projet partage enregistrerait le corps de `POST /me/discord/link/complete`
 *   (`code`, `state`) et sa reponse (`confirmationToken`), que le masque ne nettoie pas.
 */
export function posthogOptions(apiHost: string): Partial<PostHogConfig> {
  return {
    api_host: apiHost,
    person_profiles: 'identified_only',
    session_recording: {
      maskAllInputs: true,
      recordHeaders: false,
      recordBody: false,
      maskCapturedNetworkRequestFn: scrubOAuthNetworkRequest,
    },
    before_send: scrubOAuthCapture,
    capture_pageview: true,
    autocapture: true,
  };
}
